'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$RoleCode$() {
  this.c9X = null;
  this.c9Y = false;
  this.c9V = null;
  this.c9W = false;
}
export { $c_Lpresto_types$RoleCode$ as $c_Lpresto_types$RoleCode$ };
$p = $c_Lpresto_types$RoleCode$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$RoleCode$;
/** @constructor */
function $h_Lpresto_types$RoleCode$() {
}
export { $h_Lpresto_types$RoleCode$ as $h_Lpresto_types$RoleCode$ };
$h_Lpresto_types$RoleCode$.prototype = $p;
$p.csY = (function() {
  if ((!this.c9Y)) {
    this.c9X = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.c9Y = true;
  }
  return this.c9X;
});
$p.kF = (function() {
  if ((!this.c9W)) {
    this.c9V = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.c9W = true;
  }
  return this.c9V;
});
var $d_Lpresto_types$RoleCode$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$RoleCode$, "presto.types$RoleCode$", ({
  a1b: 1,
  D: 1
}));
export { $d_Lpresto_types$RoleCode$ as $d_Lpresto_types$RoleCode$ };
var $n_Lpresto_types$RoleCode$;
function $m_Lpresto_types$RoleCode$() {
  if ((!$n_Lpresto_types$RoleCode$)) {
    $n_Lpresto_types$RoleCode$ = new $c_Lpresto_types$RoleCode$();
  }
  return $n_Lpresto_types$RoleCode$;
}
export { $m_Lpresto_types$RoleCode$ as $m_Lpresto_types$RoleCode$ };
//# sourceMappingURL=presto.types$-Role-Code$.js.map
